<template>
  <div class="psq-table">
    <table>
      <thead>
        <tr>
          <th>测试题目</th>
          <th>测试结果</th>
          <th>正常范围</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>总分</td>
          <td>{{ getScore('totalScore') }}</td>
          <td>0-7</td>
        </tr>
        <tr>
          <td>呼吸</td>
          <td>{{ getScore('breathing') }}</td>
          <td>-</td>
        </tr>
        <tr>
          <td>嗜睡</td>
          <td>{{ getScore('sleepiness') }}</td>
          <td>-</td>
        </tr>
        <tr>
          <td>行为</td>
          <td>{{ getScore('behavior') }}</td>
          <td>-</td>
        </tr>
        <tr>
          <td>其他</td>
          <td>{{ getScore('other') }}</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PsqTable',
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  methods: {
    getScore(key) {
      if (key === 'totalScore') {
        // 直接获取原始数据的 total，不带 "分" 后缀
        return this.model.model?.total || 0;
      }
      // 从原始数据 model.model.depthValue 中获取各维度分数
      // keyName 是 A/B/C/D，对应 呼吸/嗜睡/行为/其他
      const depthValue = this.model.model?.depthValue || [];
      const keyNameMap = {
        breathing: 'A',
        sleepiness: 'B',
        behavior: 'C',
        other: 'D'
      };
      const targetKeyName = keyNameMap[key];
      const item = depthValue.find(item => item.keyName === targetKeyName);
      return item?.value || 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.psq-table {
  margin: 20px 0;
  
  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ddd;
    
    th, td {
      padding: 12px;
      text-align: left;
      border: 1px solid #ddd;
      font-size: 16px;
    }
    
    th {
      background-color: #f5f5f5;
      font-weight: bold;
      color: #333;
    }
    
    td {
      color: #666;
      background-color: white;
    }
  }
}
</style>